import { create } from "zustand";
import { TOKEN_KEY } from "@/config";

interface Login {
  hasLogin: boolean;
  isVisitor: boolean;
  mobile: string;
}

const loginState: Login = {
  hasLogin: !!localStorage.getItem(TOKEN_KEY),
  mobile: "",
  isVisitor: false,
};

interface LoginStore extends Login {
  setHasLogin: (hasLogin: boolean) => void;
  setIsVisitor: (isVisitor: boolean) => void;
  setMobile: (mobile: string) => void;
}

const loginStore = create<LoginStore>((set) => ({
  ...loginState,
  setHasLogin: (hasLogin) => {
    set({ hasLogin });
  },
  setIsVisitor: (isVisitor) => {
    set({ isVisitor });
  },
  setMobile: (mobile) => {
    set({ mobile });
  },
}));

export default loginStore;
